import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Bookmarks",
  published_at: "2026-02-04",
  summary: "Save interesting opportunities with one click and manage them from a dedicated dashboard.",
  tags: ["Platform"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Found an opportunity worth a closer look but not ready to create a full pursuit? Now you can bookmark it. One click saves any opportunity to your Bookmarks dashboard, where you can see deadlines, current status, and which team members have also bookmarked it. When you're ready to move forward, convert a bookmark into a pursuit with a single click."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "25d2ea7e-393d-54b9-81f0-8e27ef97ad90"
    }), "\n", _jsx(_components.p, {
      children: "Bookmarks give your team a lightweight way to track promising leads without the overhead of setting up a full pursuit. Use them as a shared \"watch list\" so nothing slips through the cracks during busy solicitation periods."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
